import styled from 'styled-components'
import { useOnChangeFilter } from '@/features/shop/components/ProductFilter/interactions/useOnChangeFilter'
import { FilterPill } from '@/features/shop/components/ProductFilter/FilterOptions/FilterPill'
import { ResetFilterButton } from '@/features/shop/components/ProductFilter/ResetFilterButton'
import { DISPLAY_FORMAT } from '@/features/shared/constants/analytics'
import { SEARCH_FILTER_TYPE } from '@/features/shared/constants/global'
import { useTrackFilterUtilityClicked } from '@/features/shared/analytics/filters'
import { FilterScrollWrapper } from '@/features/shop/components/ProductFilter/FilterScrollWrapper'
import { Row } from '@shipt/design-system-layouts'
import { useValidSearchParams } from '@/features/shared/hooks/search'

type Props = { index: number }

export const DealsOption = ({ index }: Props) => {
  const searchParams = useValidSearchParams()
  const { onChangeFilter } = useOnChangeFilter()
  const { active_deals: activeDeals = false } = searchParams
  const { ACTIVE_DEALS } = SEARCH_FILTER_TYPE
  const trackFilterUtilityClicked = useTrackFilterUtilityClicked()

  const handleOnClickFilter = () => {
    const params = { active_deals: !activeDeals }
    onChangeFilter(params)
    trackFilterUtilityClicked({
      params,
      filter_active: !activeDeals,
      filter_value: String(!activeDeals),
      list_index: index,
      utility_type: 'filter',
      display_format: DISPLAY_FORMAT.HORIZONTAL,
      display_sublocation: ACTIVE_DEALS,
    })
  }
  return (
    <DealsOptionWrapper facet={ACTIVE_DEALS} index={index}>
      <DealsOptionRow>
        <DealsOptionPill isActive={activeDeals} onClick={handleOnClickFilter}>
          Deals
        </DealsOptionPill>
        {!!activeDeals && <ResetFilterButton filterType={ACTIVE_DEALS} />}
      </DealsOptionRow>
    </DealsOptionWrapper>
  )
}

const DealsOptionWrapper = styled(FilterScrollWrapper)`
  position: relative;
  display: block;
`

const DealsOptionPill = styled(FilterPill)<{ isActive: boolean }>`
  && {
    padding-right: ${({ isActive }) => (isActive ? 32 : 16)}px;
  }
`

const DealsOptionRow = styled(Row)`
  position: relative;
`
